// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1neNh","errors":"Errors_errors__2Kaoo"};